var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.treeProps && _vm.nodeKey)?_c('div',{staticClass:"out-type"},[_c('el-tree',{ref:"treeContent",attrs:{"data":_vm.treeData,"highlight-current":true,"current-node-key":_vm.currentNodeKey,"node-key":_vm.nodeKey,"props":_vm.treeProps},on:{"node-click":_vm.onNodeClick}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }